export default __webpack_public_path__ + "static/media/x.fb4b4443.png";